import * as React from 'react'

import CustomSelect, { SelectType } from 'src/common/CustomSelect.component'

import terminationReasons from 'src/utils/termination-reason'

const map = require('lodash/map')
const keys = require('lodash/keys')

export interface TerminationReasonSelectProps {
  value?: string
  selectType?: SelectType
  onChange: (value: string) => void
}

class TerminationReasonSelect extends React.PureComponent<TerminationReasonSelectProps> {
  get terminationReasonsOptions() {
    return map(keys(terminationReasons), key => ({
      value: key,
      label: terminationReasons[key]
    }))
  }

  render() {
    const { value, onChange, selectType } = this.props

    const options = this.terminationReasonsOptions

    return (
      <CustomSelect
        value={value}
        type={selectType}
        options={options}
        onChange={onChange}
        style={{ width: '100%' }}
        placeholder="Termination reason"
        getOptionValue={option => option.value}
        getOptionLabel={option => option.label}
        valueContainerStyle={{ textAlign: 'left' }}
        placeholderStyle={{ fontWeight: 'light', fontStyle: 'italic' }}
      />
    )
  }
}

export default TerminationReasonSelect


// WEBPACK FOOTER //
// ./src/routes/terminations/termination-flow/components/TerminationReasonSelect.component.tsx